/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import once from 'lodash.once';
import { isProductionUrl } from 'src/core/utils/api/environment';
import { LuisConstants } from 'src/core/utils/LuisConstants';

/**
 * This singleton initializes Application Insights and return an instance
 * to the caller.
 */
export const getApplicationInsightsInstance = once(() => {
    const applicationInsightsInstance = new ApplicationInsights({
        config: {
            instrumentationKey: isProductionUrl()
                ? LuisConstants.Telemetry.AppInsightsKeyProduction
                : LuisConstants.Telemetry.AppInsightsKeyPpe,
            enableDebug: false,
            disableExceptionTracking: true, // Exception tracking can have PII
            disableAjaxTracking: true, // The URLs in the AJAX tracking can have PII
            isCookieUseDisabled: true
        }
    });

    applicationInsightsInstance.loadAppInsights();

    return applicationInsightsInstance;
});
